/* eslint-disable */
import { Theme, createStyles, makeStyles } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    slideContent: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      fontSize: '14px',
      lineHeight: '20px',
      textDecorationLine: 'underline',
      color: '#0F8AC0',
      cursor: 'pointer',
      '&:hover': {
        color: '#086b97'
      },
      boxSizing: 'content-box',
      padding: '0px 4px'
    },
    slideIcon: {
      marginRight: theme.spacing(1),
      marginTop: theme.spacing(0.35),
      width: '13px',
      height: '15px'
    },
    slide: {
      marginTop: theme.spacing(1.5),
      '& > div:hover': {
        background: 'none'
      },
      '&~&': {
      },
      boxSizing: 'content-box',
    },
    slideNumber: {
      float: 'right',
    }
  });

export const useStyles = makeStyles(styles);